export default __webpack_public_path__ + "static/media/hit_and_run.d86bbdc3.png";